import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import EventUsersBadge from './EventUsersBadge';

const MAX_ORGS_BADGE_NUMBER = 5;
const MAX_COHOSTS_BADGE_NUMBER = 4; // -1 to account for the current user

const OrganizersBadges = ({
  isEditable,
  onClick,
  data: { groups, cohosts, scanners, operators, photographers, host }
}) => {
  const { t } = useTranslation(['events']);
  // Adding up all the organizers, including 1 for the host user themselves.
  const totalNumberOfOrganizers =
    1 +
    groups.length +
    scanners.length +
    operators.length +
    cohosts.length +
    photographers.length;

  // We are showing a maximum of MAX_BADGE_NUMBER organizations.
  const organizationsBadges = useMemo(
    () => groups.slice(0, MAX_ORGS_BADGE_NUMBER),
    [groups]
  );

  // We are showing a maximum of MAX_BADGE_NUMBER cohosts.
  const cohostsBadges = useMemo(
    () => (host ? [...cohosts.slice(0, MAX_COHOSTS_BADGE_NUMBER), host] : []),
    [cohosts, host]
  );

  return (
    <div className="mt-6">
      <EventUsersBadge
        onClick={onClick}
        title={t('events:eventDetails.organizers')}
        squareBadges={organizationsBadges.length > 0}
        secondaryDefaultText={
          totalNumberOfOrganizers === 1 && isEditable
            ? t('events:eventDetails.justYouSoFar')
            : t('events:eventDetails.total', {
                count: totalNumberOfOrganizers
              })
        }
        data={
          organizationsBadges.length > 0 ? organizationsBadges : cohostsBadges
        }
        additionalGuests={
          organizationsBadges.length > 0
            ? Math.max(groups.length - MAX_ORGS_BADGE_NUMBER, 0)
            : Math.max(cohosts.length - MAX_COHOSTS_BADGE_NUMBER, 0)
        }
      />
    </div>
  );
};

export default OrganizersBadges;
